export default "__VITE_ASSET__18e67357__"